// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName
//
// Controllers from app/javascript/instrument_take and unified_report
// are registered manually (not generated by manifest).

import { application } from "./application"

import LocalTimeController from "./local_time_controller"
import TestDynamicsController from "./test_dynamics_controller"
import PairAnalysisChartController from "./pair_analysis_chart_controller"
import PairAnalysisFormController from "./pair_analysis_form_controller"
import ClipboardController from "./clipboard_controller"
import CookieConsentController from "./cookie_consent_controller"
import FlashMessageController from "./flash_message_controller"
import ModalController from "./modal_controller"
import NavbarController from "./navbar_controller"
import SidebarMobileController from "./sidebar_mobile_controller"
import NotificationBellController from "./notification_bell_controller"
import ProductReleaseBannerController from "./product_release_banner_controller"
import DropdownController from "./dropdown_controller"
import PsychologistClientPickerController from "./psychologist_client_picker_controller"
import NestedFormController from "./nested_form_controller"
import MultiStepCaptureController from "./multi_step_capture_controller"
import LandingScrollController from "./landing_scroll_controller"
import PricingIntervalController from "./pricing_interval_controller"
import TestingProcessTestsOrderController from "./testing_process_tests_order_controller"
import TestingProcessScheduleController from "./testing_process_schedule_controller"
import TestingProcessApplyScheduleController from "./testing_process_apply_schedule_controller"
import AnalysisFrameRefreshController from "./analysis_frame_refresh_controller"
import AnalysisProgressController from "./analysis_progress_controller"
import TestResultImportController from "./test_result_import_controller"
import TestAssignmentFormController from "./test_assignment_form_controller"
import AssignmentWizardController from "./assignment_wizard_controller"
import CatalogComboboxController from "./catalog_combobox_controller"
import QuickAssignFormController from "./quick_assign_form_controller"
import DismissibleController from "./dismissible_controller"
import InterfaceTourController from "./interface_tour_controller"
import InterfaceTourLauncherController from "./interface_tour_launcher_controller"
import AssignmentStartController from "./assignment_start_controller"
import YandexCaptchaController from "./yandex_captcha_controller"
import ScheduleGridController from "./schedule_grid_controller"
import ScheduleJournalController from "./schedule_journal_controller"
import ScheduleReturnController from "./schedule_return_controller"
import ScheduleViewController from "./schedule_view_controller"
import AutoSubmitController from "./auto_submit_controller"
import TimeZoneHintController from "./time_zone_hint_controller"
import TimeZoneDetectController from "./time_zone_detect_controller"
import ZoneTimeController from "./zone_time_controller"
import AppointmentExtraClientsController from "./appointment_extra_clients_controller"
import AppointmentFormatController from "./appointment_format_controller"
import AppointmentPanelController from "./appointment_panel_controller"
import AppointmentConflictController from "./appointment_conflict_controller"
import WorkingHoursController from "./working_hours_controller"
import BookableOrderController from "./bookable_order_controller"
import CallRoomController from "./call_room_controller"
import {
  QuestionnaireWizardController,
  RankWithinItemController,
  TimedMatrixController,
  LabilityConductorController,
  LabilityChecklistController,
  OrderedSelectionController,
  StimulusWizardController,
  SubmitLoadingController,
} from "../instrument_take/index.js"
import { UnifiedReportController } from "../unified_report/index.js"

application.register("local-time", LocalTimeController)
application.register("test-dynamics", TestDynamicsController)
application.register("pair-analysis-chart", PairAnalysisChartController)
application.register("pair-analysis-form", PairAnalysisFormController)
application.register("questionnaire-wizard", QuestionnaireWizardController)
application.register("rank-within-item", RankWithinItemController)
application.register("timed-matrix", TimedMatrixController)
application.register("lability-conductor", LabilityConductorController)
application.register("lability-checklist", LabilityChecklistController)
application.register("clipboard", ClipboardController)
application.register("cookie-consent", CookieConsentController)
application.register("flash-message", FlashMessageController)
application.register("modal", ModalController)
application.register("navbar", NavbarController)
application.register("sidebar-mobile", SidebarMobileController)
application.register("notification-bell", NotificationBellController)
application.register("product-release-banner", ProductReleaseBannerController)
application.register("dropdown", DropdownController)
application.register("psychologist-client-picker", PsychologistClientPickerController)
application.register("nested-form", NestedFormController)
application.register("ordered-selection", OrderedSelectionController)
application.register("stimulus-wizard", StimulusWizardController)
application.register("multi-step-capture", MultiStepCaptureController)
application.register("landing-scroll", LandingScrollController)
application.register("pricing-interval", PricingIntervalController)
application.register("testing-process-tests-order", TestingProcessTestsOrderController)
application.register("testing-process-schedule", TestingProcessScheduleController)
application.register("testing-process-apply-schedule", TestingProcessApplyScheduleController)
application.register("analysis-frame-refresh", AnalysisFrameRefreshController)
application.register("analysis-progress", AnalysisProgressController)
application.register("test-result-import", TestResultImportController)
application.register("test-assignment-form", TestAssignmentFormController)
application.register("assignment-wizard", AssignmentWizardController)
application.register("catalog-combobox", CatalogComboboxController)
application.register("quick-assign-form", QuickAssignFormController)
application.register("dismissible", DismissibleController)
application.register("interface-tour", InterfaceTourController)
application.register("interface-tour-launcher", InterfaceTourLauncherController)
application.register("assignment-start", AssignmentStartController)
application.register("yandex-captcha", YandexCaptchaController)
application.register("schedule-grid", ScheduleGridController)
application.register("schedule-journal", ScheduleJournalController)
application.register("schedule-return", ScheduleReturnController)
application.register("schedule-view", ScheduleViewController)
application.register("auto-submit", AutoSubmitController)
application.register("time-zone-hint", TimeZoneHintController)
application.register("time-zone-detect", TimeZoneDetectController)
application.register("zone-time", ZoneTimeController)
application.register("appointment-extra-clients", AppointmentExtraClientsController)
application.register("appointment-format", AppointmentFormatController)
application.register("appointment-panel", AppointmentPanelController)
application.register("appointment-conflict", AppointmentConflictController)
application.register("working-hours", WorkingHoursController)
application.register("bookable-order", BookableOrderController)
application.register("call-room", CallRoomController)
application.register("submit-loading", SubmitLoadingController)
application.register("unified-report", UnifiedReportController)
